// extracted by mini-css-extract-plugin
module.exports = {"layered-image":"layered-image-module__layered-image___GXPS3","layeredImage":"layered-image-module__layered-image___GXPS3"};